import { useEffect } from 'react';

/**
 * Keep the screen awake while a session runs (architecture §4). The lock is dropped when the tab is hidden, so it is
 * re-acquired on return. Unsupported browsers simply do nothing.
 */
export function useWakeLock(active: boolean) {
  useEffect(() => {
    if (!active || !('wakeLock' in navigator)) return;
    let sentinel: WakeLockSentinel | null = null;
    let released = false;
    const acquire = async () => {
      if (released || document.visibilityState !== 'visible') return;
      try { sentinel = await navigator.wakeLock.request('screen'); } catch { /* denied or low battery */ }
    };
    void acquire();
    document.addEventListener('visibilitychange', acquire);
    return () => {
      released = true;
      document.removeEventListener('visibilitychange', acquire);
      void sentinel?.release().catch(() => undefined);
    };
  }, [active]);
}
